import styled from "styled-components";
import { GridColDef } from "@mui/x-data-grid";
import { useEffect, useState } from "react";
import { useQuery } from "@tanstack/react-query";
import { useNavigate, useParams } from "react-router-dom";
import { urlOperator } from "../../../utils/url";
import { ButtonWraper, GoBackButton } from "../../../components/GoBackButton";
import { StyledButton } from "../../../components/Button/button";
import { GetOrdersDetailsPayloadResponse } from "../../../services/orders/orders-details-get-by-id/types";
import { getOrdersDetailsGetById } from "../../../services/orders/orders-details-get-by-id";
import { LoadingBackDrop } from "../../../components/loader";
import { theme } from "../../../helpers/theme";
import { ReactComponent as Back } from "../../../assets/icons/back.svg";
import { Divider } from "@mui/material";
import {
  Summary,
  SummaryPropertyItem,
} from "../../operator-views/operator-orders-details/components/Summary";
import {
  dateFormating,
  getPlaceEnum,
  getPurposeFromEnum,
  getServiceFromEnum,
  getStatusFromEnum,
  getTemperatureConditionsEnum,
  getTypeFromEnum,
} from "../../operator-views/operator-orders-offering/helpers";
import { AdditionalInfo } from "../../operator-views/operator-orders-details/components/AdditionalRemarks";
import { QuantumDetailOrder } from "../../operator-views/operator-orders-details/components/QuantumDetailOrder";
import { getOrdersDetailsPricelistByIdSubcontractor } from "../../../services/orders/orders-details-pricelist-get-by-id-subcontractor";
import { OrdersDetailsPricelistByIdSubcontractorPayload } from "../../../services/orders/orders-details-pricelist-get-by-id-subcontractor/types";
import SubcontractorOffers from "./components/subcontractor-offers";
import SessionService from "../../../services/session-service";
import { UserRoles } from "../../../types/user-roles";
import AccessDenied from "../../common-views/access-denied/access-denied";
import Icon from "../../../components/icon";
export const SubcontractorOfferView = () => {
  const { id } = useParams();
  const navigate = useNavigate();
  const [subcontractorOffer, setSubcontractorOffer] = useState<
    OrdersDetailsPricelistByIdSubcontractorPayload[]
  >([]);
  const [userRole, setUserRole] = useState<UserRoles>(
    SessionService.getUser() !== null &&
      SessionService.getUser().typ_uzytkownika
  );
  const [error, setError] = useState(false);
  const body = {
    id_zamowienie: id,
  };
  const GetOrdersDetailsPricelistByIdSubcontractor = useQuery(
    ["OrdersDetailsPricelistByIdSubcontractor"],
    () => getOrdersDetailsPricelistByIdSubcontractor(body),
    {
      refetchOnMount: true,
      refetchOnWindowFocus: false,
      onSuccess(res) {
        setSubcontractorOffer([res.data.payload]);
      },
      onError(err) {
        setError(true);
      },
    }
  );
  useEffect(() => {
    if (SessionService.getUser === null) {
      SessionService.setOfferSubcontractorView({
        emailHasBeenSent: true,
        id: `${id}`,
      });
      navigate("/login");
    }
    if (!SessionService.getOfferSubcontractorView()) {
      //Wymusza wylogowanie aktualnego użytkownika
      {
        SessionService.clearUserSession();
        SessionService.clearLoggedUserData();
        SessionService.setOfferSubcontractorView({
          emailHasBeenSent: true,
          id: `${id}`,
        });
        navigate("/login");
      }
    }
  }, []);

  const detailTableInfoPart1: SummaryPropertyItem[] = [
    {
      propertyKey: "Nr zamówienia",
      propertyName: "Nr zamówienia",
      propertyValue: `${subcontractorOffer[0]?.numer_zamowienia}`,
    },
    {
      propertyKey: "Status",
      propertyName: "Status",
      propertyValue: `${getStatusFromEnum(
        subcontractorOffer[0]?.status_zamowienia
      )}`,
    },
    {
      propertyKey: "Klient",
      propertyName: "Klient",
      propertyValue: `${subcontractorOffer[0]?.klient.nazwa}`,
    },
    {
      propertyKey: "Kontakt",
      propertyName: "Kontakt",
      propertyValue: `${subcontractorOffer[0]?.klient.telefon}`,
    },

    {
      propertyKey: "Cel zamówienia",
      propertyName: "Cel zamówienia",
      propertyValue: `${getPurposeFromEnum(
        subcontractorOffer[0]?.uslugiZamowione.cel_zamowienia
      )}`,
    },
    {
      propertyKey: "Miejsce",
      propertyName: "Miejsce",
      propertyValue: `${getPlaceEnum(subcontractorOffer[0]?.miejsce)}`,
    },
    {
      propertyKey: "Usługi dodatkowe",
      propertyName: "Usługi dodatkowe",
      propertyValue:
        subcontractorOffer[0]?.uslugiZamowione.uslugi_dodane.length > 0
          ? subcontractorOffer[0]?.uslugiZamowione.uslugi_dodane.map(
              (item, index) =>
                `${getServiceFromEnum(item)}${
                  index + 1 <
                  subcontractorOffer[0]?.uslugiZamowione.uslugi_dodane.length
                    ? ", "
                    : ""
                }`
            )
          : "",
    },
    {
      propertyKey: "Liczba usł. dodatkowych",
      propertyName: "Liczba usł. dodatkowych",
      propertyValue:
        subcontractorOffer[0]?.uslugiZamowione.uslugi_dodane.length > 0 &&
        subcontractorOffer[0]?.uslugiZamowione.ilosc_dodatkowych
          ? subcontractorOffer[0]?.uslugiZamowione.ilosc_dodatkowych.toString()
          : "",
    },
  ];
  const detailTableInfoPart2: SummaryPropertyItem[] = [
    {
      propertyKey: "Rodzaj towaru",
      propertyName: "Rodzaj towaru",
      propertyValue: `${getTypeFromEnum(subcontractorOffer[0]?.rodzaj_towaru)}`,
    },
    {
      propertyKey: "Opis towaru",
      propertyName: "Opis towaru",
      propertyValue: subcontractorOffer[0]?.opis_towaru
        ? `${subcontractorOffer[0]?.opis_towaru}`
        : "-",
    },
  ];
  const detailTableInfoPart3: SummaryPropertyItem[] = [
    {
      propertyKey: "Termin rozpoczęcia",
      propertyName: "Termin rozpoczęcia",
      propertyValue: `${dateFormating(
        subcontractorOffer[0]?.termin_rozpoczecia
      )}`,
    },
    {
      propertyKey: "Termin zakończenia",
      propertyName: "Termin zakończenia",
      propertyValue: `${dateFormating(
        subcontractorOffer[0]?.termin_zakonczenia
      )}`,
    },

    {
      propertyKey: "Warunek temp",
      propertyName: "Warunek temp",
      propertyValue: `${getTemperatureConditionsEnum(
        subcontractorOffer[0]?.warunek_temperaturowy
      )}`,
    },
    {
      propertyKey: "Rodzaj składowania",
      propertyName: "Rodzaj składowania",
      propertyValue: subcontractorOffer[0]?.skladowanie_plaskie
        ? "składowanie płaskie"
        : subcontractorOffer[0]?.wysokie_skladowanie
        ? "wysokie składowanie"
        : subcontractorOffer[0]?.polki
        ? "półki"
        : "",
    },
  ];
  const detailAdditionalInfo: SummaryPropertyItem[] = [
    {
      propertyKey: "Specjalny sprzęt",
      propertyName: "Specjalny sprzęt",
      propertyValue: subcontractorOffer[0]?.specjalny_sprzet
        ? `${subcontractorOffer[0]?.specjalny_sprzet}`
        : "-",
    },
    {
      propertyKey: "Opis usługi",
      propertyName: "Opis usługi",
      propertyValue: subcontractorOffer[0]?.opis_uslugi
        ? `${subcontractorOffer[0]?.opis_uslugi}`
        : "-",
    },
  ];
  if (
    GetOrdersDetailsPricelistByIdSubcontractor.isLoading ||
    GetOrdersDetailsPricelistByIdSubcontractor.isRefetching
  ) {
    return <LoadingBackDrop loading={true} />;
  }
  return (
    <>
      {userRole === UserRoles.SUBCONTRACTOR ? (
        <SubcontractorOfferViewContainer
          onClick={() => SessionService.clearOfferSubcontractorView()}
        >
          <ViewNavigation>
            <Redirect>
              <ButtonWraper
                onClick={() => navigate("/subcontractor/subcontractors")}
              >
                <Icon
                  width="20px"
                  height="20px"
                  noPadding
                  icon={<Back width="20px" height="20px" />}
                />
                <Description>Powrót</Description>
              </ButtonWraper>
            </Redirect>
          </ViewNavigation>

          {error ? (
            <ErrorContainer>
              <ErrorMessage>
                Zamówienie należy do innego podwykonawcy.
              </ErrorMessage>
            </ErrorContainer>
          ) : (
            <>
              <WhitePage>
                <SectionTitle>Szczegóły zamówienia</SectionTitle>
                <Divider sx={{ marginBottom: "26px" }} />
                <SummaryTableContainer>
                  <Summary data={detailTableInfoPart1} />
                </SummaryTableContainer>
                <SummaryTableContainer>
                  <Summary data={detailTableInfoPart2} />
                </SummaryTableContainer>
                <SummaryTableContainer>
                  <Summary data={detailTableInfoPart3} />
                </SummaryTableContainer>
                <Summary data={detailAdditionalInfo} />
                <AdditionalInfo
                  data={[
                    {
                      propertyKey: "Dodatkowe uwagi do całosci zamówienia",
                      propertyName: "Dodatkowe uwagi",
                      propertyValue: subcontractorOffer[0]?.dodatkowe_uwagi
                        ? `${subcontractorOffer[0]?.dodatkowe_uwagi}`
                        : "-",
                    },
                  ]}
                />
              </WhitePage>
              {subcontractorOffer[0]?.oferty.map((item, index) =>
                item.oferty_podwykonawcy[0].status_oferty_podwykonawcy === 1 ? (
                  <SubcontractorOffers
                    id_oferta={(index + 1).toString()}
                    index={index}
                    oferta={item}
                  />
                ) : (
                  <></>
                )
              )}
            </>
          )}
        </SubcontractorOfferViewContainer>
      ) : (
        <AccessDenied />
      )}
    </>
  );
};
const SubcontractorOfferViewContainer = styled.div`
  display: flex;
  flex-direction: column;
  //TODO
  margin-left: 0;
  padding: 0 10px;

  @media ${theme.device.laptop} {
    margin-left: 310px;
    padding-right: 50px;
  }
`;
const ViewNavigation = styled.div`
  width: 100%;
  display: flex;
  flex-direction: row;
  justify-content: space-between;
  @media (max-width: 340px) {
    flex-direction: column;
  }
`;
const SummaryTableContainer = styled.div`
  display: flex;
`;
const ServicesContainer = styled.div`
  //margin:30px 0px;
  @media (max-width: 500px) {
    width: 100%;
    display: flex;
    flex-direction: column;
  }
`;
const QuantumContainer = styled.div``;
const SectionTitle = styled.div`
  margin-bottom: 14px;
  font-family: ${theme.fonts.interRegular} !important;
  font-style: normal;
  font-weight: 500;
  font-size: 14px;
  line-height: 20px;
  color: black;
  font-family: "Inter";
  color: ${theme.colors.black_primaryText};
  @media (max-width: 500px) {
    margin-top: 16px;
  }
`;
const WhitePage = styled.div`
  background: ${theme.colors.white};
  border-radius: 8px;
  padding: 32px;
  margin-bottom: 20px;
  @media (max-width: 500px) {
    padding: 0px 10px;
    padding-bottom: 16px;
  }
`;
const Redirect = styled.div`
  display: flex;
  align-items: center;
  padding-bottom: 24px;
`;
const TableRow = styled.div`
  height: 163px;
  width: 100 %;
  display: flex;
  //margin-left: ${window.screen.width > 1024 ? "350px" : "0"};
  //padding-right: ${window.screen.width > 1024 ? "50px" : "0"};
`;

const ErrorContainer = styled.div`
  width: 70%;
  max-width: 580px;
  flex-wrap: wrap;

  @media (max-width: 500px) {
    width: 80%;
    margin-left: 0;
  }

  display: flex;
  justify-content: space-between;
  background-color: white;
  padding: 20px;
  border-radius: 10px;
`;

const ErrorMessage = styled.span`
  font-family: ${theme.fonts.interRegular};
  font-style: normal;
  font-weight: 400;
  font-size: 14px;
  line-height: 20px;
`;
const Description = styled.div`
  padding: 5px 10px;
  font-family: ${theme.fonts.interRegular};
  font-style: normal;
  font-weight: ${theme.fontWeight.normal};
  font-size: 14px;
  line-height: 20px;
  color: ${theme.colors.black_primaryText};
  overflow-wrap: break-word;
`;
